import { render, staticRenderFns } from "./exit.vue?vue&type=template&id=3128e090&scoped=true"
import script from "./exit.vue?vue&type=script&lang=js"
export * from "./exit.vue?vue&type=script&lang=js"
import style0 from "./exit.vue?vue&type=style&index=0&id=3128e090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3128e090",
  null
  
)

export default component.exports